import { Box, Tab, Tabs } from '@mui/material'
import { useState } from 'react'

import TabPanel from '@/components/layouts/TabPanel'
import type { ActivationGroup } from '@/features/activationGroup/types'
import { BiddingDashboardOverallBidTable } from '@/features/bidding/components/BiddingDashboardOverallBidTable'
import { BiddingDashboardPerGroupAndPtuTable } from '@/features/bidding/components/BiddingDashboardPerGroupAndPtuTable'
import type { AllocatedVolumes } from '@/features/bidding/types/allocatedVolumes'

interface BiddingDashboardTabsProps {
  activationGroups: ActivationGroup[] | undefined
  allocatedVolumes: AllocatedVolumes
}

export const BiddingDashboardTabs = ({ activationGroups, allocatedVolumes }: BiddingDashboardTabsProps) => {
  const [activeTab, setActiveTab] = useState(0)

  return (
    <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={activeTab} onChange={(_, newValue) => setActiveTab(newValue)}>
          <Tab label="Volumes per Group and PTU" />
          <Tab label="Bid status per market" />
        </Tabs>
      </Box>

      <TabPanel
        index={0}
        style={{ flex: 1, overflow: 'hidden' }}
        sx={{ pt: 2, height: '100%', display: 'flex', flexDirection: 'column' }}
        value={activeTab}
      >
        <BiddingDashboardPerGroupAndPtuTable activationGroups={activationGroups} allocatedVolumes={allocatedVolumes} />
      </TabPanel>

      <TabPanel
        index={1}
        style={{ flex: 1, overflow: 'hidden' }}
        sx={{ pt: 2, height: '100%', display: 'flex', flexDirection: 'column' }}
        value={activeTab}
      >
        <BiddingDashboardOverallBidTable activationGroups={activationGroups} allocatedVolumes={allocatedVolumes} />
      </TabPanel>
    </Box>
  )
}
